<template>
  <div class="select-row" v-if="data">
    <div class="label">{{ label }}</div>
    <!--searchSiftName[searchSiftEnum[type]] -->
    <div class="row__content">
      <span
        v-for="(item, index) in data"
        class="select-btn"
        :key="index"
        @click="handleClick({ type: type, data: item }, $event)"
      >
        <template>{{ item.name }}</template>
      </span>
    </div>
  </div>
</template>

<script>
import { searchSiftEnum, searchSiftName } from '../defines'
import emitter from '@/mixins/emitter'
export default {
  props: ['type', 'data', 'name', 'label'],
  mixins: [emitter],
  data() {
    return {
      searchSiftEnum,
      searchSiftName
    }
  },
  methods: {
    handleClick(data, event) {
      this.$emit('input', data, event)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
.select-row {
  min-height: 22px;
  line-height: 22px;
  padding: 8px 0;
  position: relative;
  .label {
    float: left;
    color: #aaaaaa;
    font-weight: normal;
    text-align: left;
    margin-right: 14px;
    font-size: 13px;
  }
  .bold {
    color: #666666;
    font-weight: bold;
  }
  .row__content {
    display: inline-block;
    position: relative;
    max-width: 950px;
    vertical-align: top;
  }
}
@include b(select-btn) {
  padding: 0 6px;
  margin: 0 5px;
  line-height: 22px;
  display: inline-block;
  color: #333333;
  cursor: pointer;
  position: relative;
  &:hover {
    color: #f13232;
  }
  @include m(active) {
    border-radius: 2px;
    color: #ffffff;
    background: #f13232;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.05);
    &:hover {
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/AddPurchase/components/SelectRow.vue